import React from 'react';
import { Outlet } from 'react-router-dom';

const ExtraLayout: React.FC = () => {
    return (
        <div className=" adminuiux-wrap">
            <main className="adminuiux-content">
                {/*Page body*/}
                <div className="container-fluid">
                    <Outlet />
                </div>
            </main>
        </div>
    );
};

export default ExtraLayout;
